import React from "react";

/**
 * Renders the exact HTML that the backend send-reply endpoint produces,
 * inside a sandboxed iframe so styles cannot leak.
 * Keep in sync with backend `send_reply` HTML template.
 */
export function buildReplyHtml(subject, body) {
  const esc = (s) =>
    (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const safe = esc(body).replace(/\n\n/g, "</p><p>").replace(/\n/g, "<br>");
  return `
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="font-family:Arial,sans-serif;background:#f5f7fb;margin:0">
  <tr><td align="center" style="padding:24px 12px">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="max-width:560px;background:#ffffff;border-radius:12px;overflow:hidden">
      <tr><td style="background:#0B1E3F;padding:16px 24px;color:#C9A961;font-size:11px;letter-spacing:3px;text-transform:uppercase">NextShore Immigration</td></tr>
      <tr><td style="padding:24px 28px;color:#334155;font-size:15px;line-height:1.6">
        <p>${safe}</p>
        <p style="margin:22px 0 0 0;color:#64748b;font-size:12px">Sent by NextShore Immigration. We will never ask for your password or card details by email.</p>
      </td></tr>
    </table>
  </td></tr>
</table>`;
}

export default function ReplyPreviewModal({ open, onClose, onSend, subject, body, to, replyTo, sending }) {
  if (!open) return null;
  const html = buildReplyHtml(subject, body);
  return (
    <div
      data-testid="reply-preview-modal"
      className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl max-h-[92vh] overflow-hidden rounded-2xl bg-white shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 border-b flex items-center justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400">Email preview</div>
            <div className="font-serif text-lg text-slate-800">{subject}</div>
            <div className="text-xs text-slate-500 mt-0.5">
              To: <span className="text-slate-700">{to}</span>
              {replyTo && <> · Reply-To: <span className="text-slate-700">{replyTo}</span></>}
            </div>
          </div>
          <button data-testid="reply-preview-close" onClick={onClose} className="text-slate-400 hover:text-slate-800 text-xl leading-none">×</button>
        </div>

        <div className="flex-1 overflow-y-auto bg-slate-100">
          <iframe
            data-testid="reply-preview-iframe"
            title="Email preview"
            className="w-full h-[440px] border-0"
            sandbox=""
            srcDoc={`<!doctype html><html><body style="margin:0">${html}</body></html>`}
          />
        </div>

        <div className="px-5 py-4 border-t flex items-center justify-between gap-3">
          <p className="text-[11px] text-slate-500">
            This is exactly what the client will see in their inbox.
          </p>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="rounded-xl border border-slate-200 bg-white hover:bg-slate-50 px-4 py-2 text-sm font-semibold"
            >
              Cancel
            </button>
            <button
              onClick={onSend}
              disabled={sending}
              data-testid="reply-preview-confirm-send"
              className="rounded-xl bg-[#0B1E3F] hover:bg-[#162A4D] text-white px-5 py-2 text-sm font-semibold disabled:opacity-60"
            >
              {sending ? "Sending…" : "Confirm & Send"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
